<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>
      <v-toolbar>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-container>
          <h3>App server settings</h3>
          <qrcode-vue
            class="light-bg"
            :value="value"
            :size="size"
            level="H"
          ></qrcode-vue>
        </v-container>
        <v-card-text v-if="!dist">
         SERVER IP : {{ip}}
         <br/>
         Server running mode : Development 
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { setAuthToken, MAIN_SERVER, DIST } from "../../../lib/http.common";
import QrcodeVue from "qrcode.vue";
import Aes from "../../../lib/aes";

export default {
  components: {
    QrcodeVue,
  },  
  data() {
    return {
      value: Aes.enc(MAIN_SERVER, "isigirijibun"),
      ip:MAIN_SERVER,
      dist:DIST,
      size: 250,
      overlay: true,
      dialog: false,
      dialogtitle: "Edit Rep",
      dialogerror: null,
      search: "",
      name: "Settings",
      tabitems: [{ name: "", index: 0 }],
      tab: null,
      errormessage: null,
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.overlay = false;
  },
  beforeCreate() {
    console.clear();
    setAuthToken();
  },
};
</script>

<style scoped>
.v-application .mb-6 {
  margin-bottom: 0px !important;
}
.light-bg {
  background-color: white;
  padding: 10px;
  display: inline-flex;
}
</style>